import { defineMessages } from 'react-intl';

export default defineMessages({
    addAnotherTeacher: {
        id: 'app.components.TeacherConfirmation.addAnotherTeacher',
        defaultMessage: 'Add another teacher'
    },
    printSignInCard: {
        id: 'app.components.TeacherConfirmation.printSignInCard',
        defaultMessage: 'Print sign-in card'
    },
    done: {
        id: 'app.components.TeacherConfirmation.done',
        defaultMessage: 'Done'
    },
    downloading: {
        id: 'app.components.TeacherConfirmation.header',
        defaultMessage: 'downloading...'
    }
});



// WEBPACK FOOTER //
// ./app/components/teacher-confirmation/messages.js